import Components from 'slotworks/components/components';
import { SpinRecordBuilder } from 'slotworks/integration/revolver/builders/records/spin-record-builder';
import Gameplay from 'slotworks/model/gameplay/gameplay-model';
import Record from 'slotworks/model/gameplay/records/record';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import GameInit from 'states/game-init';
import FreeSpinsRecord from './freespin-record';
import { PatsPaydayResponseSchema } from './response-schema';
import WildStickyRecorder from './wild-sticky-record';
import { SpinResponseSchema } from 'slotworks/integration/revolver/schema/spin-record-schema';
import revolverModel from 'slotworks/integration/revolver/model/revolver-model';

class DeadlyOutlawSpinRecordBuilder extends SpinRecordBuilder {
    public filter(data: any): boolean {
        let spinResponse: SpinResponseSchema;

        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
        }

        return spinResponse && spinResponse.RESULTS !== undefined && (revolverModel.isSpin(spinResponse.RESULTS.game) || revolverModel.isFreespin(spinResponse.RESULTS.game));
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const toReturn = super.build(gameplay, data)[0] as SpinRecord;
        let spinResponse: PatsPaydayResponseSchema;

        Components.matrix.resetSymbols();

        if (data && data.data) {
            spinResponse = data.data as PatsPaydayResponseSchema;
        }

        if (spinResponse && spinResponse.RESULTS !== undefined && spinResponse.RESULTS.state && spinResponse.RESULTS.state.retriggers) {
            if (spinResponse.RESULTS.state.retriggers > 0) {
                toReturn.freespinsTriggered = true;
                toReturn.freespinsWon = spinResponse.RESULTS.state.retriggers;
            }
        }

        const freeSpinRecord = new FreeSpinsRecord();
        let state = spinResponse.RESULTS.state;
        if (spinResponse.RESULTS.next_game_state) {
            state = spinResponse.RESULTS.next_game_state;
        }
        freeSpinRecord.freespinsWon = state.total;
        freeSpinRecord.totalWinCash = state.total_win_cash;
        freeSpinRecord.triggering_game = state.triggering_game;
        freeSpinRecord.next_game = spinResponse.RESULTS.next_game;
        freeSpinRecord.gameName = spinResponse.RESULTS.game;
        freeSpinRecord.remainingFreespins = state.remain;
        freeSpinRecord.total = state.total;
        freeSpinRecord.recover = true;
        freeSpinRecord.parentBonusGameState = spinResponse.RESULTS.parentBonusGameState;

        const wildStickyRecord = new WildStickyRecorder();
        wildStickyRecord.gameName = state.game;
        wildStickyRecord.stickedWildsList = state.stickedWildsList;
        wildStickyRecord.persistedProgress = spinResponse.RESULTS.persisted_progress;
        toReturn.results.push(wildStickyRecord);

        GameInit.freeSpinsWin = spinResponse.RESULTS.state.total_win_cash;
        toReturn.results.push(freeSpinRecord);
        Components.betBar.setCurrentWin(0);

        GameInit.wildStickyRecorder = wildStickyRecord;
        return [toReturn];
    }
}
export default new DeadlyOutlawSpinRecordBuilder();



// WEBPACK FOOTER //
// ./src/integration/spin-record-builder.ts